module.exports = __webpack_public_path__ + "img/plan.72b7e70d.png";